import React from 'react';

import './Tooltip.scss';

export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
        this.hideTimer = null;
    }

    componentWillUnmount() {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }
    }

    cancelHide = () => {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    };

    show = () => {
        this.cancelHide();
        this.setState({ visible: true });
    };

    scheduleHide = () => {
        this.cancelHide();
        this.hideTimer = setTimeout(() => {
            this.setState({ visible: false });
        }, 200);
    };

    hideImmediate = () => {
        this.cancelHide();
        this.setState({ visible: false });
    };

    handleOnKeyDown = event => {
        // Enter
        if (event.keyCode === 13) {
            this.show();
        }
        // Escape
        if (event.keyCode === 27) {
            this.hideImmediate();
        }
    };

    render() {
        const { children, text, id = 'tooltip-content' } = this.props;
        const { visible } = this.state;

        return (
            <div className="tooltip">
                <button
                    type="button"
                    aria-describedby={id}
                    onMouseEnter={this.show}
                    onFocus={this.show}
                    onMouseLeave={this.scheduleHide}
                    onBlur={this.hideImmediate}
                    onKeyDown={this.handleOnKeyDown}>
                    {children}
                </button>

                <div
                    id={id}
                    role="tooltip"
                    className={`tooltip-text-wrapper ${visible ? 'visible' : ''}`}
                    onMouseEnter={this.show}
                    onMouseLeave={this.scheduleHide}>
                    <p className="tooltip-text">{text}</p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js